module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[87]208.49de27d.woff2";